export enum NavigationPermission {
  ApproverGroupSelect = "ApproverGroup.Select",
  PicklistSelect = "Picklist.Select",
  CompetenceManagerSelect = "CompetenceManager.Select",
  PermitAdminSelect = "PermitAdmin.Select",
  VideoAdminSelect = "VideoAdmin.Select",
  CompanySelect = "Company.Select",
  TeamSelect = "Team.Select",
  PersonSelect = "Person.Select",
  CampusSelect = "Campus.Select",
  BuildingSelect = "Building.Select",
  ZoneSelect = "Zone.Select",
  LocationTypeSelect = "LocationType.Select",
  ServiceSelect = "Service.Select",
  LocationSelect = "Location.Select",
  AssetSelect = "Asset.Select",
  RamsSelect = "Rams.Select",
  PermitRequestSelect = "PermitRequest.Select"
}
